<!--
  @description 体检报告
  @author xiehan
  @date 2018/12/18
-->
<template>
  <div class="examinationReport__content">
    <el-form ref="searchForm" :model="searchForm" :inline="true">
      <el-form-item :label="$t('logComponentManage.site')" input-width="auto">
        <g-select :list="siteList" v-model="searchForm.siteCode"></g-select>
      </el-form-item>
      <el-form-item :label="$t('common.time')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="searchForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$t('examinationReport.type')" input-width="auto">
        <g-select v-model="searchForm.type" :list="select_type"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" 
          v-g-rac="gRac('examinationReport@search')"
          @click="search"
          v-text="$t('common.search')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
      <template slot="control-column" slot-scope="{data}">
        <el-table-extend-control 
          :control="tableControl" 
          :data="data" 
          :label="$t('common.handle')">
        </el-table-extend-control>
      </template>
    </el-table-extend>
  </div>
</template>

<script>
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import examinationReportBiz from '@/logic/statistics/examinationReportBiz'
  import { extend } from '@/utils/tool'
  import TimeFormat from '@/utils/timeFormat'

  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        searchForm: {
          startTime: new Date(new Date().toLocaleDateString()).getTime(),
          endTime: '',
          type: '',
          siteCode: ''
        },
        tableControl: [
          {
            label: this.$t('common.check'),
            callback: (row, index, data) => {
              this.$router.push({
                name: 'reportDetail',
                query: {
                  id: row.id,
                  type: Object.keys(this.select_type).filter(item => this.select_type[item] === row.type)[0]
                }
              })
            },
            rac: () => this.gRac('examinationReport@check')
          }
        ],
        siteList: {},
        select_type: {}
      }
    },
    methods: {
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          let list = {}
          data.dataList.map((item) => {
            list[item.siteCode] = item.name
          })
          this.siteList = list
          this.searchForm.siteCode = Object.keys(list)[0]
          this.preInitTable()
          this.searchTable()
        })
      },
      async preInitTable () {
        await this.dGetDictionaryByCode('checkReportType')
        this.select_type = { ...this.dDictionary.checkReportType }
        this.searchForm.type = Object.keys(this.select_type)[0]
        this.initTable()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'examinationReport.table',
          head: ['updateTime', 'checkCount', 'alarmCount', 'type'],
          requestFun: this.searchTable,
          headOpt: {
            type: {
              formatter: 'Dictionary',
              formatterDic: this.select_type
            }
          }
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        if (!reqData.endTime) reqData.endTime = new Date().getTime()
        examinationReportBiz.findCheckReportByPage(reqData).then((data) => {
          if (data && data.dataList) {
            data.dataList.map(item => {
              item.updateTime = TimeFormat.getFormatTime(item.updateTime)
            })
          }
          this.tData = data
        })
      }
    },
    mounted () {
      this.getSiteList()
    }
  }
</script>